import request from '@/axios/axios'

export function fetchList(query) {
  return request({
    url: '/ColumnFilter/getColumnDictByUri',
    method: 'post',
    data: query
  })
}

export function fetchSelected(query) {
  return request({
    url: '/ColumnFilter/getFilter',
    method: 'post',
    data: query
  })
}

export function fetchUpdate(query) {
  return request({
    url: '/ColumnFilter/update',
    method: 'post',
    data: query
  })
}



// WEBPACK FOOTER //
// ./src/api/changeColumon.js